import _app from './server';
import {
    auth__reset
} from 'redux/actions/auth';
import store from 'redux/store';

import axios from 'axios';


let storage = null;
let token = "";

const instance = axios.create({
    baseURL: _app.api,
    withCredentials: false
});


instance.interceptors.request.use(req => {
    storage = JSON.parse(localStorage.getItem("guardexpert_logon"));

    if (storage) {
        token = storage.info.id;
    }
    req['headers']['authorization'] = token;
    req['headers']['Access-Control-Allow-Origin'] = "*";
    req['headers']['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,PATCH,OPTIONS';
    return req;
}, error => {
    console.log("instance.interceptors.request :\n" + error);
    return Promise.reject(error);
});

instance.interceptors.response.use(res => {
    return res;
}, error => {
    console.log("instance.interceptors.response:\n", error);
    if (!error.response) {
        store.dispatch(auth__reset());
        return Promise.reject(error);
    }
    if (error.response.status === 401) {
        store.dispatch(auth__reset());
    }
    return Promise.reject(error);
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios.js